export const API_BASE = "https://www.breakingbadapi.com/api";
export const API_EPISODES = API_BASE.concat("/episodes");
export const API_CHARACTER = API_BASE.concat("/characters");
export const API_QUOTES = API_BASE.concat("/quotes");



